<app-spinner [isBusy]="showSpinner"></app-spinner>
<app-alert></app-alert>
<app-confirm-dialog [openModal]="showModal"></app-confirm-dialog>
<app-select-dlg *ngIf="showSelectDialog" [displayItems]="selectDialogList" [selectDlgMode]="selectDlgMode" [auditType]="riApp"
    (done)="selectDialogApplyChanges()" (cancel)='closeSelectDlg()' (sendPackages)="SendPackagesProcess()" ></app-select-dlg>

<div class="notification-reviewer">
  <div class="packages-pane">
    <div class="upper-pane">
      <div class="panelbar-wrapper">
        <kendo-panelbar [expandMode]="1" height="90%" (stateChange)="FaildOrPassedPackagePanelChanged($event)" >
          <kendo-panelbar-item [title]="'Failed Audit Packages'" [expanded]="expanded" *ngIf="riApp !='reverseAudit'" >
            <ng-template kendoPanelBarContent>
              <div class="panelbar-content">
                <kendo-tabstrip (tabSelect)="tabSelect($event)">
                  <kendo-tabstrip-tab class="'tab-txt'" [title]="''" [disabled]="true">
                  </kendo-tabstrip-tab>
                  <kendo-tabstrip-tab [title]="'To'" [selected]="true">
                    <ng-template kendoTabContent>
                      <email-tree [data]="dataFailedTo" (selectRecipient)="selectRecipient($event)" (selectProperty)="selectProperty($event)"
                      (toggleProperty)="toggleProperty($event)" (updateNotificationPackage)="updateNotificationPackage($event)">loading</email-tree>
                    </ng-template>
                  </kendo-tabstrip-tab>
                  <kendo-tabstrip-tab [title]="'Cc'">
                    <ng-template kendoTabContent>
                      <email-tree [data]="dataFailedCc" (selectRecipient)="selectRecipient($event)" (selectProperty)="selectProperty($event)"
                      (toggleProperty)="toggleProperty($event)" (updateNotificationPackage)="updateNotificationPackage($event)">loading</email-tree>
                    </ng-template>
                  </kendo-tabstrip-tab>
                  <kendo-tabstrip-tab [title]="'Bcc'">
                    <ng-template kendoTabContent>
                      <email-tree [data]="dataFailedBcc" (selectRecipient)="selectRecipient($event)" (selectProperty)="selectProperty($event)"
                      (toggleProperty)="toggleProperty($event)" (updateNotificationPackage)="updateNotificationPackage($event)">loading</email-tree>
                    </ng-template>
                  </kendo-tabstrip-tab>
                </kendo-tabstrip>
              </div>
            </ng-template>
          </kendo-panelbar-item>
          <kendo-panelbar-item [title]="passedPackageTitle" [expanded]="!expanded">
            <ng-template kendoPanelBarContent>
              <div class="panelbar-content">
                <kendo-tabstrip (tabSelect)="tabSelect($event)">
                  <kendo-tabstrip-tab [title]="''" [disabled]="true">
                  </kendo-tabstrip-tab>
                  <kendo-tabstrip-tab [title]="'To'" [selected]="true">
                    <ng-template kendoTabContent>
                      <email-tree [data]="dataPassedTo" [auditType]="riApp" (selectRecipient)="selectRecipient($event)" (selectProperty)="selectProperty($event)"
                      (toggleProperty)="toggleProperty($event)" (updateNotificationPackage)="updateNotificationPackage($event)">loading</email-tree>
                    </ng-template>
                  </kendo-tabstrip-tab>
                  <kendo-tabstrip-tab [title]="'Cc'">
                    <ng-template kendoTabContent>
                      <email-tree [data]="dataPassedCc" [auditType]="riApp" (selectRecipient)="selectRecipient($event)" (selectProperty)="selectProperty($event)"
                      (toggleProperty)="toggleProperty($event)" (updateNotificationPackage)="updateNotificationPackage($event)">loading</email-tree>
                    </ng-template>
                  </kendo-tabstrip-tab>
                  <kendo-tabstrip-tab [title]="'Bcc'">
                    <ng-template kendoTabContent>
                      <email-tree [data]="dataPassedBcc" [auditType]="riApp" (selectRecipient)="selectRecipient($event)" (selectProperty)="selectProperty($event)"
                      (toggleProperty)="toggleProperty($event)" (updateNotificationPackage)="updateNotificationPackage($event)" >loading</email-tree>
                    </ng-template>
                  </kendo-tabstrip-tab>
                </kendo-tabstrip>
              </div>
            </ng-template>
          </kendo-panelbar-item>
        </kendo-panelbar>
      </div>
    </div>
    <div class="lower-pane">
      <button class="slds-button cvt-secondary" (click)="expandAll(true)">Expand All</button>
      <button class="slds-button cvt-secondary" (click)="expandAll(false)">Collapse All</button>
    </div>
  </div>
  <div class="full-email-pane">
    <header>
      <h4 (click)="click()" >{{universalID}} - {{accountName}} </h4>
      <div *ngIf="showHeading">
        <label for="email-from">From </label>
        <input id="email-from" type="text" readonly [value]="from" />
        <br/>
        <label for="email-to">Recipient </label>
        <input id="email-to" name="emailTo" type="text" maxlength="256" [(ngModel)]="recipient" #emailTo="ngModel" [readonly]="!isRecipientEditable()"
               (blur)="onBlurRecipientEmail($event)" required [pattern]="emailPattern" />
               <span *ngIf="emailTo.invalid   && (emailTo.dirty || emailTo.touched ) && isRecipientEditable()" class="cvt-icon-information grid-cmd-icons errorIcon" title="Invalid email format"></span>
        <br/>
        <label for="email-subject">Subject </label>
        <input id="email-subject" type="text" readonly [value]="subject" />
        <br/>
      </div>
      <div>
        <button class="slds-button cvt-primary" (click)="saveTemplateEditing()" [disabled]="!CanSavePackageContent()" *ngIf="!showHeading" >Save</button>
      </div>
    </header>
    <main>
      <div  class="email-html-body">
        <iframe  *ngIf="showHeading"  [srcdoc]="message"  #frame [height]="(IE||Edge)?'100%':''"></iframe>
        <ckeditor [class]='showHeading?"hideCkedit":""'
          (change)="ckEditEvent($event, 'change',ckeditCtrl)"
          (ready)="ckEditEvent($event, 'ready',ckeditCtrl)"
          (blur)="ckEditEvent($event, 'blur',ckeditCtrl)"
          (focus)="ckEditEvent($event, 'focus',ckeditCtrl)"
          id="ckeditorid" #ckeditCtrl="ngModel" debounce="1000" [config]=""
          [editorUrl] ="ckEditorUrl"
          [(ngModel)]="ckeditorText"
          [readOnly]="lastSelectedItem==null||(lastSelectedItem.IncludeInPackage?false:true)"
        >
        </ckeditor>
        </div>
    </main>
    <footer>
      <button id="btn-send-notifications" class="slds-button cvt-primary" (click)="StartSendNotificationsProcess()" [disabled]="!any(All)">Send Selected Notifications</button>
    </footer>
  </div>
</div>
<br />
<hr />
